import { useEffect, useState } from "react";
import { MdMenu } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import logo from "../images/Menu-Charter-Logo.png"
import api from "../api/axiosInstance";
import moment from "moment";
const TopBar = (props) => {
  const [lastSynced, setLastSynced] = useState("")
  const GetLastSync = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "CanvasUsers/GetLastSync",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      console.log(response)
      if (response.status === 200) {
        setLastSynced(response.data)
      }
    });
  };
  useEffect(() => {
    GetLastSync()
  }, [props.userId]);
  const [selectedAY, setSelectedAY] = useState(localStorage.getItem("yearCode") ?? "2526");

  const changeAY = (year) => {
    setSelectedAY(year);
    localStorage.setItem("yearCode", year);
    window.location.reload();
  }
  return (
    <div className="top-bar">
      <img src={logo} className="d-md-none logo" />
      <span className="d-md-none mobile-menu" onClick={() => props.setClosed(false)}>
        <MdMenu />
      </span>
      <span className="LastSynced">
        <label>Last Update: {moment(lastSynced.endDate).format("DD-MM-yyyy HH:mm a")}</label>
      </span>
      <span className="selectedAY">
        <label>Academic Year: 2025 - 2026</label>
        {/* <select placeholder="Select AY" value={selectedAY} className="form-control form-control-sm" onChange={(e) => changeAY(e.target.value)}>
          <option value={2425}>{2425}</option>
          <option value={2526}>{2526}</option>
        </select> */}
      </span>
      <span className="greetings d-none d-md-inline-block">
        Welcome, <b>{localStorage.getItem("name")}</b>
      </span>
      <Link to="/ChangePassword" className="profile d-none d-md-inline-block">
        <RiLockPasswordLine /> Change Password
      </Link>
    </div>
  );
};

export default TopBar;
